<template>
  <div class="disputed-charges">
    <div v-if="disputedChargeDetails?.length">
      <div
        v-for="(property, index) in disputedChargeDetails"
        :key="property"
        class="disputed-charges__container">
        <accordian
          :expanded="property.expanded"
          :item="property"
          :index="index"
          @onCardToggle="onAccordianToggle">
          <div
            slot="accordian-header-content"
            class="disputed-charges__container__accordian-header">
            <div class="disputed-charges__container__accordian-header__content">
              {{ property.chargeName }}
            </div>
          </div>
          <div
            v-if="property.expanded"
            slot="accordian-body"
            class="disputed-charges__container__accordian-body">
            <div
              v-for="item in disputedChargesConstant"
              :key="item.label"
              class="disputed-charges__container__accordian-body__item">
              <span
                class="disputed-charges__container__accordian-body__item--title">
                {{ item.label }}:
              </span>
              <span
                class="disputed-charges__container__accordian-body__item--value">
                {{ item.type === "currency" ? property.currency : "" }}
                {{ getValue(property, item.slotKey) }}
              </span>
            </div>
          </div>
        </accordian>
      </div>
    </div>
    <div v-else>No disputed charges found.</div>
  </div>
</template>

<script>
import { disputedChargesConstant } from "@/config/disputeDataConstant.js";

export default {
  name: "DisputedCharges",
  props: {
    caseDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      disputedChargeDetails: Object.values(
        this.caseDetails?.disputedChargeDetails || {}
      ),
      disputedChargesConstant,
    };
  },
  methods: {
    onAccordianToggle(data, index) {
      event.stopPropagation();
      let newArray = [...this.disputedChargeDetails];
      newArray[index] = {
        ...data,
        expanded: !data.expanded,
      };
      this.disputedChargeDetails = newArray;
    },
    getValue(property, slotKey) {
      if (slotKey === "disputeCategory") {
        return property.disputeCategory.label;
      }
      return property[slotKey];
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.disputed-charges {
  &__container {
    cursor: pointer;
    position: relative;
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    &__accordian-header {
      display: flex;
      align-items: center;
      &__content {
        display: flex;
        align-items: center;

        @include media("<tablet") {
          flex-direction: column;
        }
      }
    }

    &__accordian-body {
      padding: 1rem;
      border: 1px solid var(--Gray-200);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: flex;
      flex-direction: column;
      margin-left: 0;
      cursor: default;

      @include media("<tablet") {
        margin-left: 40px;
      }

      &__item {
        display: flex;
        margin-bottom: 8px;
        &--title {
          color: var(--Gray-600);
          display: flex;
          flex-direction: column;
          flex-basis: 100%;
          flex: 1;
        }
        &--value {
          display: flex;
          flex-direction: column;
          flex-basis: 100%;
          flex: 1;
          flex: 2;
        }
      }
    }
  }
  .accordian__header {
    margin-left: 0;
  }
}
</style>
